/**
 * Identité mémorisée pour la page "Bienvenue de retour" :
 * stocke le nom d'utilisateur de façon obfusquée dans localStorage.
 * La session (token) reste en sessionStorage et est perdue à la fermeture de l'onglet/navigateur.
 */

const STORAGE_KEY = "road-alerte-remembered-identity";
const OBFUSCATE_KEY = "RoadAlerte2026";

function xorCipher(str: string, key: string): string {
  let result = "";
  for (let i = 0; i < str.length; i++) {
    result += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return result;
}

function encode(str: string): string {
  const encoded = xorCipher(str, OBFUSCATE_KEY);
  return btoa(unescape(encodeURIComponent(encoded)));
}

function decode(encoded: string): string {
  try {
    const decoded = decodeURIComponent(escape(atob(encoded)));
    return xorCipher(decoded, OBFUSCATE_KEY);
  } catch {
    return "";
  }
}

export function setRememberedUsername(username: string): void {
  if (!username?.trim()) return;
  try {
    localStorage.setItem(STORAGE_KEY, encode(username.trim()));
  } catch (e) {
    console.warn("rememberedIdentity: set failed", e);
  }
}

export function getRememberedUsername(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const username = decode(raw);
    return username || null;
  } catch {
    return null;
  }
}

export function clearRememberedUsername(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn("rememberedIdentity: clear failed", e);
  }
}

export function hasRememberedIdentity(): boolean {
  return getRememberedUsername() != null;
}
